<template>
  <div>
    <div id="multi-print-area" style="display: none;">
      <div class="multi-print-page" v-for="(user, index) in selectedUsers.filter((item) => !item.is_default_user)" :key="index">
        <img v-if="currentEntity.logo" class="multi-watermark img-watermark" :src="currentEntity.logo" alt="">
        <div v-else class="multi-watermark">VISIPONT</div>
        <div class="multi-print-title">{{($t("users.form.quickPass")).toLocaleUpperCase()}}</div>
        <div class="img-container">
          <img class="user-img" v-if="user.current_entity?.image" :src="user.current_entity.image" alt="">
          <div class="qr-border">
            <img class="qr-img" v-if="quickPass" :src="quickPass[user.current_entity.id]" alt="">
          </div>
        </div>
        <div class="multi-print-text">{{ currentEntity.name.toLocaleUpperCase() }}</div>
        <div class="multi-print-text">{{ user.FullName }}</div>
        <div class="multi-print-text">{{ user.UserType.toLocaleUpperCase() }}</div>
        <div class="multi-print-small">{{ $t("users.form.printedBy") }} {{userDetails.first_name}} {{userDetails.last_name}} {{ $t("common.at") }} {{ getTodayDate }}</div>
      </div>
    </div>
  
  <VpFormModal
    v-if="showNotAllowedAction"
    :showCloseIcon="false"
    :showHorizontalLine="true"
  >
    <template v-slot:header>
      <span>{{ $t("users.form.printQuickpass") }}</span>
    </template>

    <template v-slot:content>
      <div class="content-wrapper">
        <p class="vp-font-weight-700 vp-mb-24">
          {{ $t("users.form.actionNotAllowed") }}
        </p>
        <p class="vp-lh-24">{{ $t("users.form.printingNotPermitted") }}</p>
      </div>
    </template>

    <template v-slot:footer>
      <VpButton :text="$t('common.okay')" @click="$bvModal.hide('quickpass')" />
    </template>
  </VpFormModal>

  <VpFormModal
    v-else
    id="quickpass"
    :showCloseIcon="true"
    :showHorizontalLine="true"
  >
    <template v-slot:header>
      <span>{{ $t("users.form.printQuickpass") }}</span>
    </template>

    <template v-slot:content>
      <div v-if="!showPrintOptions" class="content-wrapper">
        <p class="vp-font-weight-700 vp-mb-24">
          {{ $t("users.form.actionApplied") }}
        </p>
        <p class="vp-lh-24 vp-mb-24">
          {{ $t("users.form.defaultPrintingNotPermitted") }}
          {{ selectedDefaultUsers }}
        </p>
        <p>{{ $t("users.form.applyToOthers") }}</p>
      </div>
      <div class="content-wrapper" v-show="showPrintOptions">
        <p
          v-html="$t('users.form.massactionPrintMessage')"
          class="vp-mb-32 vp-lh-24"
        />

        <v-radio-group
          class="customField-radio quickpass-radio"
          v-model="printer"
          @change="radioChanged"
        >
          <!-- Local printer -->
          <v-radio
            :label="printerOptions[0].label"
            :value="printerOptions[0].value"
            :disabled="isLoading"
          />

          <!-- Online printer with optional resend icon -->
          <div v-show="!isLoading" class="radio-wrapper">
            <v-radio
              :class="{
                'alert-text':
                  printerChecksDone &&
                  availableKiosks.length === 0 &&
                  printer === 2,
              }"
              :label="printerOptions[1].label"
              :value="printerOptions[1].value"
            />

            <button
              v-if="printerChecksDone && availableKiosks.length === 0"
              class="resend-printer-check"
              @click="resend"
            >
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9.5" r="9" fill="#103F5E" />
                <path
                  d="M13.7735 3.73234C13.6396 3.5953 13.4195 3.49252 13.2277 3.50043C13.0282 3.50965 12.821 3.57685 12.6819 3.73234C12.5429 3.88651 12.4554 4.07758 12.4554 4.29104C12.4554 4.5443 12.4554 4.79677 12.4554 5.04964C12.1945 4.82761 11.9147 4.62864 11.619 4.45641C10.7545 3.95305 9.76934 3.68688 8.76973 3.68688C7.99112 3.68688 7.23542 3.84316 6.52362 4.15137C5.83653 4.4489 5.21959 4.87465 4.68992 5.41688C4.16025 5.95911 3.74437 6.59068 3.45373 7.29407C3.15266 8.02275 3 8.79637 3 9.59344C3 10.3905 3.15266 11.1641 3.45373 11.8928C3.74437 12.5962 4.16025 13.2278 4.68992 13.77C5.21959 14.3122 5.83653 14.738 6.52362 15.0355C7.23542 15.3437 7.99112 15.5 8.76973 15.5C10.0106 15.5 11.1931 15.1027 12.1893 14.3511C12.5298 14.0943 12.6025 13.6034 12.3515 13.2548C12.1005 12.9061 11.6212 12.8318 11.2806 13.0888C10.5494 13.6403 9.68117 13.9319 8.7696 13.9319C6.43287 13.9319 4.53173 11.9857 4.53173 9.59344C4.53173 7.20117 6.43287 5.25494 8.76973 5.25494C9.83357 5.25494 10.83 5.65341 11.5957 6.35719C11.3241 6.35719 11.0525 6.35719 10.7808 6.35719C10.6662 6.35719 10.5517 6.35719 10.4371 6.35719C10.2389 6.35719 10.0317 6.44547 9.89136 6.5891C9.7575 6.72614 9.6571 6.95147 9.66482 7.1478C9.67383 7.35204 9.73948 7.56419 9.89136 7.7065C10.042 7.84881 10.2286 7.93842 10.4371 7.93842C10.7512 7.93842 11.064 7.93842 11.378 7.93842C11.88 7.93842 12.382 7.93842 12.884 7.93842C12.9986 7.93842 13.1131 7.93842 13.2277 7.93842C13.6447 7.93842 14 7.57605 14 7.1478C14 6.82628 14 6.50608 14 6.18457C14 5.67067 14 5.15677 14 4.64287C14 4.52559 14 4.40832 14 4.29104C14 4.08812 13.9138 3.87597 13.7735 3.73234Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>

          <!-- Spinner when loading -->
          <div v-if="isLoading" class="spinner-container">
            <b-spinner class="printer-spinner" variant="secondary" />
            <span class="alt-text">{{
              $t("users.form.checkingForPrinters")
            }}</span>
          </div>
        </v-radio-group>

        <!-- Conditional printer messages -->
        <div v-if="printerChecksDone && !isLoading">
          <p v-if="availableKiosks.length === 0" class="no-kiosks">
            {{ $t("users.form.noKiosksAvailable") }}
          </p>
          <p v-else class="vp-mt-24">
            <vp-multiselect
              label="name"
              title="Kiosk to print from"
              v-model="selectedKiosk"
              :options="availableKiosks"
              :showPlaceholderIcon="true"
              dropDownStyle="relative"
              :maxHeight="165"
              :showOptionsBorder="true"
            />
          </p>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <template v-if="showPrintOptions">
        <VpButton
          @click="onPrint"
          :text="$t('common.print')"
          :disabled="$v.selectedKiosk.$invalid"
          class="print-btn"
        />

        <VpButton
          :text="$t('common.cancel')"
          @click="$bvModal.hide('quickpass')"
          :isDanger="true"
        />
      </template>
      <template v-else>
        <VpButton
          @click="showPrintOptions = !showPrintOptions"
          :text="$t('common.continue')"
        />

        <VpButton
          :text="$t('common.cancel')"
          @click="$bvModal.hide('quickpass')"
          :isDanger="true"
        />
      </template>
    </template>
  </VpFormModal>
</div>
</template>

<script>
import moment from "moment";
import kioskService from "../../../services/setting";
import { mapGetters, mapActions } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
export default {
  validations: {
    selectedKiosk: {
      required: requiredIf(function () {
        return this.printer === 2;
      }),
    },
  },
  data() {
    return {
      selectedUsers: [],
      selectedDefaultUsers: "",
      showNotAllowedAction: false,
      showPrintOptions: true,
      printer: 1,
      printerOptions: [
        { label: "Local printer", value: 1 },
        { label: "Online printer", value: 2 },
      ],
      availableKiosks: [],
      isLoading: false,
      printerChecksDone: false,
      selectedKiosk: null,
      quickPass: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity", "userDetails"]),
    getTodayDate() {
      const formattedDate = moment().format("DD/MM/YYYY - h:mm A");
      return formattedDate;
    },
  },
  methods: {
    ...mapActions("users", ["fetchQuickPasses"]),
    async radioChanged(val) {
      if (val !== 2) {
        this.printerChecksDone = false;
        return;
      }

      this.isLoading = true;
      this.printerChecksDone = false;

      try {
        const { data: availableKiosks } = await kioskService.getOnlineKiosks();
        this.availableKiosks = availableKiosks || [];
        if (this.availableKiosks.length === 1)
          this.selectedKiosk = this.availableKiosks[0];
      } catch (error) {
        console.error("Failed to fetch kiosks:", error);
        this.availableKiosks = [];
      } finally {
        this.isLoading = false;
        this.printerChecksDone = true;
      }
    },
    async resend() {
      this.isLoading = true;
      this.printerChecksDone = false;

      try {
        const { data: availableKiosks } = await kioskService.getOnlineKiosks();
        this.availableKiosks = availableKiosks || [];
      } catch (error) {
        console.error("Failed to fetch kiosks:", error);
        this.availableKiosks = [];
      } finally {
        this.isLoading = false;
        this.printerChecksDone = true;
        if (this.availableKiosks.length === 1)
          this.selectedKiosk = this.availableKiosks[0];
      }
    },
    async onPrint() {
      if (this.printer === 1) {
        console.log("#TODO local print");
        this.printPage();
      } else {
        const normalUsersIds = this.selectedUsers
          .filter((user) => !user.is_default_user)
          .map((user) => user.Data.id);

        const payload = {
          user_ids: normalUsersIds,
          kiosk_id: this.selectedKiosk.id,
        };

        kioskService.sendQuickPassIntructions(payload);
        this.$bvModal.hide("quickpass");
        this.$emit("onQuickPassPrintSubmit", this.selectedKiosk.name);
      }
    },
    printPage() {
      const printContent = document.getElementById("multi-print-area").innerHTML;
      const printWindow = window.open("", "", "width=800,height=600");

      printWindow.document.write(`
        <html>
          <head>
            <link href="https://fonts.googleapis.com/css2?family=Lato&display=swap" rel="stylesheet">
            <style>
              ${this.getPrintStyles()}
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContent}
          </body>
        </html>
      `);
      printWindow.document.close();
    },
    getPrintStyles() {
      return `
        body {
          font-family: 'Lato';
        }
        .multi-print-page {
          position: relative;
          padding: 45px;
          padding-bottom: 0;
          text-align: center;
          min-height: 95vh;
        }
        .multi-print-title {
          font-size: 9px;
          font-weight: 800;
          margin-bottom: 12px;
          position: relative;
          z-index: 1;
        }
        .multi-print-text {
          font-size: 9px;
          font-weight: 700;
          margin-top: 12px;
          position: relative;
          z-index: 1;
          
        }
        .multi-print-small {
          font-size: 7px;
          font-weight: 500;
          margin-top: 9px;
          position: relative;
          z-index: 1;
        }
        .multi-watermark {
          position: absolute;
          top: 12%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-45deg);
          font-size: 48px;
          color: rgba(0, 0, 0, 0.1);
          z-index: 0;
          pointer-events: none;
          white-space: nowrap;
        }
        .img-watermark {
          opacity: 15%;
          max-height: 142px;
          width: auto;
        }
        .qr-border {
          border: 3px solid black;
          padding: 3px;
          border-radius: 5px;
          width: 60px;
          height: 60px;
          position: relative;
          z-index: 1;
        }
        .img-container {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 16px;
          .qr-img {
            width: 60px;
            height: 60px;
          }
        }
        .user-img {
          border-radius: 5px;
          width: 64px;
          height: 64px;
        }
      `;
    },
  },
  mounted() {
    this.selectedUsers = cloneDeep(this.getModalInfo);
    console.log('selectedUsers', this.selectedUsers);
    const user_ids = this.selectedUsers.filter((item) => !item.is_default_user).map((user) => user.current_entity.id);
    this.fetchQuickPasses(user_ids).then((data) => {
      this.quickPass = data;
    });

    //#REMOVE mock data

    // //Add Default users
    // this.selectedUsers.push(
    //   {
    //     FullName: "ZAK DEFAULT",
    //     UserType: "DEFAULT MF",
    //     is_default_user: true,
    //   },
    //   {
    //     FullName: "ZAK DEFAULT",
    //     UserType: "DEFAULT MF",
    //     is_default_user: true,
    //   },
    //   {
    //     FullName: "ZAK DEFAULT",
    //     UserType: "DEFAULT MF",
    //     is_default_user: true,
    //   }
    // );

    // // OR Set all to default users
    // this.selectedUsers.forEach(user=>user.is_default_user = true);
    //#REMOVE

    const hasDefaultUsers = this.selectedUsers.some(
      (user) => user.is_default_user
    );
    const hasNormalUsers = this.selectedUsers.some(
      (user) => !user.is_default_user
    );

    this.selectedDefaultUsers = this.selectedUsers
      .filter((user) => user.is_default_user)
      .map((user) => `(${user.FullName} - ${user.UserType})`)
      .join(", ");

    //case => Some of the selected users are normal users
    if (hasNormalUsers && hasDefaultUsers) this.showPrintOptions = false;

    //case => All selected users are default users
    if (hasDefaultUsers && !hasNormalUsers) this.showNotAllowedAction = true;
  },
};
</script>

<style lang="scss">
#quickpass___BV_modal_content_ {
  border-radius: 26px;
}

.quickpass-radio .v-input--radio-group__input {
  gap: 19px;
}

.content-wrapper {
  color: #4a4a4a;
  font-weight: 400;
  font-size: 16px;
  b {
    font-weight: 700;
  }
}

.radio-wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
}

.printer-spinner {
  width: 18px;
  height: 18px;
  color: #103f5e !important;
  border-width: 2px;
  margin-inline-end: 15px;
}

.spinner-container {
  display: flex;
  align-items: center;
}

.alt-text {
  color: #103f5e;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.25px;
  margin-inline-start: 4px;
}

.no-kiosks {
  font-weight: 600;
  font-size: 14px;
  color: #f46a6a;
  transform: translateY(8px);
  margin-bottom: 49px;
}

.alert-text label,
.alert-text i {
  color: #f46a6a !important;
}

.resend-printer-check {
  border: none;
  background-color: transparent;
  margin-left: 8px;
  cursor: pointer;
  padding: 0;
  margin-inline-start: 17px;
  transform: translateY(-2px);
}
.print-btn:disabled {
  cursor: not-allowed !important;
}
</style>
